import React from 'react'
import * as S from './styled'

interface Props {
  children: React.ReactNode
}

export const ContentBanner = ({ children }: Props) => (
  <S.BannerWrapper>
    <S.BannerBackground alt={''} src={'/images/roughstock/banner-bg.png'} />
    <S.BannerTextContent>{children}</S.BannerTextContent>
  </S.BannerWrapper>
)
